const localAgencies = [
  {
    label: 'None',
    value: null,
  },
  {
    label: 'IBL',
    value: 'ibl',
  },
];

export default localAgencies;
